import React from 'react'
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        width: '100%',
        lineHeight: 'normal',
        borderRadius: 0,
        '&:hover': {
          backgroundColor: '#89C8F3',
        },
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          padding: 2,
          backgroundColor: '#004B8D',
          '&:hover': {
            backgroundColor: '#004B8D',
          },
        },
      },
      button: {
        padding: 2,
        '&:hover': {
          backgroundColor: '#004B8D',
        },
      },
    },
  },
  typography: {
    h3: {
      fontFamily: 'ITC Officina Sans Std, sans-serif',
      fontSize: 30,
      fontWeight: 'bold',
    },
    subtitle1: {
      color: '#475362',
      lineHeight: 'inherit',
      fontFamily: 'ITC Officina Sans Std, sans-serif',
      fontWeight: 'bold',
      fontSize: 14,
    },
    body1: {
      lineHeight: 'inherit',
      color: '#68757E',
      fontFamily: 'ITC Officina Sans Std, sans-serif',
      fontSize: 10,
    },
    body2: {
      lineHeight: 'inherit',
      color: '#68757E',
      fontFamily: 'ITC Officina Sans Std, sans-serif',
    },
    subtitle2: {
      color: '#68757E',
      fontFamily: 'ITC Officina Sans Std',
      fontWeight: 'bold',
      fontSize: 15,
    },
  },
  palette: {
    primary: {
      main: '#004B8D',
      lightBlue: '#7ab2e1',
      lightBackground: '#ECECEC',
      lightBackgroundOpacity: '#ECECEC99',
      darkBackgroundOpacity: '#475362F2',
      money: '#56AF31',
      green: '#56AF31',
      mainAuctionButton: '#89C8F3',
      mainAuctionText: '#475362',
      darkAuctionText: '#171615',
      offerBackground: '#E0E0E0',
      offerText: '#68757E',
      superCelesteEspectacular: '#8EADCB',
      superCelesteEspectacularConTransparencia: '#8EADCBAD',
      azulTattersallConTransparenciaInventadoPorIgnacia: '#004B8DAD',
      otroColorAzulTattersallInventadoPorIgnaciaParaHacerMasDificilElTrabajoDeRodrigo:
        '#004B8DD9',
    },
    secondary: {
      main: '#68757E',
    },
    white: {
      main: '#fff',
    },
    black: {
      main: '#000',
    },
    green: {
      main: '#56AF31',
    },
    lightgreen: {
      main: '#56AF31',
    },
    lightgray: {
      main: '#ECECEC',
    },
    gray: {
      main: '#939393',
      backgroundOpacityTable: '#E0E0E082',
    },
    darkgray: {
      main: '#4D4D4D',
    },
    bluegray: {
      main: '#475362',
      opacityBackground: '#475362D9',
      opacity85: '#475362D9',
    },
    lightblue: {
      main: '#89C8F3',
      light: '#c6dbe8',
    },
    darkblue: {
      main: '#004B8D',
    },
    yellow: {
      main: '#f3e596',
      secondary: '#FFC038',
    },
    red: {
      main: '#f3c7c7',
      secondary: '#BE3628',
    },
  },
})
export default function Theme({ children }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}

